import { createRouter, createWebHistory } from "vue-router"

// Direct async component imports - Vue Router 4 preferred approach
// Using direct import functions instead of defineAsyncComponent wrapper

const routes = [
  {
    path: "/incoming-invoice",
    component: () => import("@/components/IncomingInvoicePage.vue"),
    name: "incoming-invoice"
  },
  {
    path: "/tour-cash-register",
    component: () => import("@/components/TourCashRegisterIndexPage.vue"),
    name: "tour-cash-register"
  },
  {
    path: "/tour-cash-register/receipt-index/:id",
    component: () => import("@/components/TourCashRegisterReceiptIndexPage.vue"),
    name: "tour-cash-register-receipt-index"
  },
  {
    path: "/tour-cash-register/receipt-create/:type/:id",
    component: () => import("@/components/TourCashRegisterReceiptCreatePage.vue"),
    name: "tour-cash-register-receipt-create"
  },
  {
    path: "/tour-cash-register/receipt-edit/:type/:id",
    component: () => import("@/components/TourCashRegisterReceiptEditPage.vue"),
    name: "tour-cash-register-receipt-edit"
  },
  {
    path: "/tour-cash-register/overview/:id",
    component: () => import("@/components/TourCashRegisterOverviewPage.vue"),
    name: "tour-cash-register-overview"
  },
  {
    path: "/tour-cash-register/receipt-overview/:id",
    component: () => import("@/components/TourCashRegisterReceiptOverviewPage.vue"),
    name: "tour-cash-register-receipt-overview"
  },
  {
    path: "/concert-create",
    component: () => import("@/components/ConcertCreatePage.vue"),
    name: "concert-create"
  },
  {
    path: "/concert-create/:id",
    component: () => import("@/components/ConcertCreatePage.vue"),
    name: "concert-create-with-tour"
  },
  {
    path: "/concert-add-oracle-codes",
    component: () => import("@/components/ConcertAddOracleCodesPage.vue"),
    name: "concert-add-oracle-codes"
  },
  {
    path: "/artist-accounting-artist-admin",
    component: () => import("@/components/ArtistAccountingArtistAdminPage.vue"),
    name: "artist-accounting-artist-admin"
  },
  {
    path: "/artist-accounting-bookkeeping",
    component: () => import("@/components/ArtistAccountingBookkeepingPage.vue"),
    name: "artist-accounting-bookkeeping"
  },
  {
    path: "/artist-accounting-overview",
    component: () => import("@/components/ArtistAccountingOverview/ArtistAccountingOverviewPage.vue"),
    name: "artist-accounting-overview"
  },
  {
    path: "/requirements-overview/",
    component: () => import("@/components/RequirementOverviewPage.vue"),
    name: "requirements-overview"
  },
  {
    path: "/requirements-admin/",
    component: () => import("@/components/RequirementAdminPage.vue"),
    name: "requirements-admin"
  },
  {
    path: "/requirements/:id",
    component: () => import("@/components/RequirementPage.vue"),
    name: "requirements"
  },
  {
    path: "/venue-specs/:id",
    component: () => import("@/components/VenueSpecsPage.vue"),
    name: "venue-specs"
  },
  {
    path: "/venue-specs-admin",
    component: () => import("@/components/VenueSpecsAdminPage.vue"),
    name: "venue-specs-admin"
  },
  {
    path: "/wiki-admin",
    component: () => import("@/components/WikiAdminPage.vue"),
    name: "wiki-admin"
  },
  {
    path: "/wiki-sub-categories/:id",
    component: () => import("@/components/WikiSubCategoriesPage.vue"),
    name: "wiki-sub-categories"
  },
  {
    path: "/wiki-content/:id",
    component: () => import("@/components/WikiContentPage.vue"),
    name: "wiki-content"
  },
  {
    path: "/wiki-view/:id",
    component: () => import("@/components/WikiViewPage.vue"),
    name: "wiki-overview"
  },
  {
    path: "/no-show-projects",
    component: () => import("@/components/NoShowProjectsPage.vue"),
    name: "no-show-projects-overview"
  },
  {
    path: "/avails-overview",
    component: () => import("@/components/AvailsOverviewPage.vue"),
    name: "avails-overview"
  },
  {
    path: "/avails-overview/artist/:filterByArtistId",
    component: () => import("@/components/AvailsOverviewPage.vue"),
    name: "avails-overview-filtered-by-artist"
  },
  {
    path: "/avails-overview/venue/:filterByVenueId",
    component: () => import("@/components/AvailsOverviewPage.vue"),
    name: "avails-overview-filtered-by-venue"
  },
  {
    path: "/avails-overview/filter/:setFilter",
    component: () => import("@/components/AvailsOverviewPage.vue"),
    name: "avails-overview-with-filter"
  },
  {
    path: "/avails-info",
    component: () => import("@/components/AvailsInfoPage.vue"),
    name: "avails-info"
  },
  {
    path: "/budget/:budgetId",
    component: () => import("@/components/BudgetPage.vue"),
    name: "budget"
  },
  {
    path: "/artist-category-assignment/:id",
    component: () => import("@/components/ArtistCategoryAssignmentPage.vue"),
    name: "artist-category-assignment"
  },
  {
    path: "/budget-overview",
    component: () => import("@/components/BudgetOverviewPage.vue"),
    name: "budget-overview"
  },
  {
    path: "/watchdog",
    component: () => import("@/components/WatchdogPage.vue"),
    name: "watchdog-page"
  },
  {
    path: "/budget-position-status",
    component: () => import("@/components/BudgetPositionStatusPage.vue"),
    name: "budget-position-status"
  },
  {
    path: "/artist-category",
    component: () => import("@/components/ArtistCategoryPage.vue"),
    name: "artist-category"
  },
  {
    path: "/budget-expected-invoice-type",
    component: () => import("@/components/BudgetPositionExpectedInvoiceTypePage.vue"),
    name: "budget-expected-invoice-type"
  },
  {
    path: "/artist-accounting-upload-type",
    component: () => import("@/components/ArtistAccountingUploadTypePage.vue"),
    name: "artist-accounting-upload-type"
  },
  {
    path: "/artist-concert-assignment/:tourId",
    component: () => import("@/components/ArtistConcertAssignmentPage.vue"),
    name: "artist-concert-assignment"
  },
  {
    path: "/signature-verification",
    component: () => import("@/components/SignatureVerification/SignatureVerificationPage.vue"),
    name: "signature-verification"
  }
  // {
  //     path: '/error',
  //     component: PageError,
  //     name: 'error',
  // },
]

const router = createRouter({
  history: createWebHistory(),
  routes,

  // Optimized scroll behavior
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // Smooth scroll to top for new routes
    return { top: 0, behavior: "smooth" }
  }
})

// Add navigation guards for performance monitoring
router.beforeEach((to, from, next) => {
  // Performance marking for route transitions
  if (performance.mark) {
    performance.mark(`route-start-${to.name || "unknown"}`)
  }
  next()
})

router.afterEach((to, _from) => {
  // Performance measurement
  if (performance.mark && performance.measure) {
    const routeName = to.name || "unknown"
    performance.mark(`route-end-${routeName}`)

    try {
      performance.measure(`route-${routeName}`, `route-start-${routeName}`, `route-end-${routeName}`)
    } catch {
      // Ignore measurement errors
    }
  }
})

export default router
